import { Box, IconButton, Typography } from '@mui/material'
import theme from 'lib/theme'
import { useState } from 'react'
import { ProductAttribute } from 'types/model/product'
import EditIcon from '@mui/icons-material/Edit'
import { convertBooleanToString } from './utils'
import { AttributeWrapper } from './Product.styled'

export const Attribute = ({
  attribute,
  language,
  handleOpenEditModal,
}: {
  attribute: ProductAttribute
  language: string
  handleOpenEditModal: (id: string) => void
}) => {
  const [hover, setHover] = useState(false)
  const displayStringValue = () => {
    return attribute.productAttributeValueString?.options?.[language] || null
  }
  const value =
    displayStringValue() ||
    attribute.productAttributeValueNumeric ||
    convertBooleanToString(
      attribute.productAttributeValueBoolean
    )?.toUpperCase()
  const name = attribute.productAttributeName?.options?.[language] || null

  if (!value && !attribute.productAttributeName) return null
  return (
    <AttributeWrapper
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}>
      <Box
        sx={{
          width: theme.spacing(6),
          padding: '16px 8px',
        }}>
        <Typography
          variant='body2'
          sx={{
            textTransform: 'upperCase',
            color: theme.palette.text.secondary,
          }}>
          {language}
        </Typography>
      </Box>
      <Box width='200px'>
        <Typography
          variant='body2'
          sx={{ color: theme.palette.text.secondary }}>
          {name}
        </Typography>
      </Box>
      <Typography variant='body2'>{value}</Typography>
      <IconButton
        onClick={() => handleOpenEditModal(attribute.id)}
        sx={{
          position: 'absolute',
          right: theme.spacing(1),
          visibility: hover ? 'visible' : 'hidden',
        }}>
        <EditIcon />
      </IconButton>
    </AttributeWrapper>
  )
}
